// Forced replacement prototype accessors methods
module.exports = require('./_library')|| !require('./_fails')(function(){
  var K = Math.random();
  // In FF throws only define methods
  __defineSetter__.call(null, K, function(){ /* empty */});
  delete require('./_global')[K];
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_object-forced-pam.js
 ** module id = 112
 ** module chunks = 0
 **/